import { useRef, useEffect } from 'react';
import JsBarcode from 'jsbarcode';

function Barcode({ code }) {
    const svgRef = useRef(null);

    useEffect(() => {
        if (!svgRef.current || !code) return;

        JsBarcode(svgRef.current, code, {
            format: 'CODE128',
            width: 2,
            height: 60,
            marginTop: 20,
            marginBottom: 20,
            displayValue: true,
        });
    }, [code]);

    return <svg ref={svgRef} style={{ width: '100%' }} />;
}

export default Barcode;
